import { createRouter, createWebHashHistory } from 'vue-router';
import vurRouter from 'vue-router';
const routes = [
  { path: '/', component: ()=>import('../pages/homeVue.vue') },
  { path: '/about', component: ()=>import('../pages/aboutComp.vue') },
  { path: '/downLoad', component: ()=>import('../pages/downloadComp.vue') },
  { path: '/product', component: ()=>import('../pages/productComp.vue') },
  { path: '/registerMobile', component: ()=>import('../pages/registerMobile.vue') },
  { path: '/registerMRes', component: ()=>import('../pages/registerMRes.vue') },
]
console.log('VueRouter',vurRouter);
const router = createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHashHistory(),
  routes, // `routes: routes` 的缩写
})

export default router
